import { useEffect, useState } from 'react';

const DESKTOP_POINTER = '(hover: hover) and (pointer: fine)';

export const isDesktopAsk = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    const { userAgent = '', platform = '', maxTouchPoints = 0 } = window.navigator;
    const mobileOrTablet = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet|Kindle|Silk/i.test(userAgent);
    // iPadOS can identify as a Mac and acquire a fine pointer from a trackpad.
    const touchMac = /Mac/i.test(platform || userAgent) && maxTouchPoints > 1;
    return !mobileOrTablet && !touchMac && window.matchMedia(DESKTOP_POINTER).matches;
};

export const useDesktopAsk = () => {
    const [desktop, setDesktop] = useState(isDesktopAsk);
    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return undefined;
        const pointer = window.matchMedia(DESKTOP_POINTER);
        const update = () => setDesktop(isDesktopAsk());
        update();
        if (pointer.addEventListener) pointer.addEventListener('change', update);
        else pointer.addListener?.(update);
        return () => {
            if (pointer.removeEventListener) pointer.removeEventListener('change', update);
            else pointer.removeListener?.(update);
        };
    }, []);
    return desktop;
};
